import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { H2 } from '../core/Heading';

export const StyledSubheader = styled.div<IThemeProps>`
  margin-bottom: 56px;
  padding: 216px 0 96px;
  background: linear-gradient(0deg, #b6ffe2 0%, rgba(182, 255, 226, 0) 100%);
  text-align: center;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    padding: 148px 0 112px;

    ${H2} {
      margin: 0 auto;
      max-width: 512px;
    }
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-bottom: 96px;
    padding: 240px 0 120px;

    ${H2} {
      max-width: 794px;
    }
  }
`;
